import { LIMITED_ACCESS, FULL_ACCESS } from "@stadium/constants/lib/permissions";

export const POINTS = "points";

export const AUTHORIZED_PAYMENT_OPTIONS = {
  stadiumWalletKey: "store_credit",
  stadiumPointsWalletKey: "global_point",
  storeSpecificPointsKey: "store_specific_point",
};

/** Payment `paymentType` values (aligned with checkout). */
export const MY_WALLET_PAYMENT_KEY = AUTHORIZED_PAYMENT_OPTIONS.stadiumWalletKey;
export const GLOBAL_POINT_PAYMENT_KEY = AUTHORIZED_PAYMENT_OPTIONS.stadiumPointsWalletKey;

export const MY_WALLET_DATA = {
  id: "default",
  name: "My Wallet",
};

export const POINTS_WALLET_DATA = {
  id: POINTS,
};

export const MY_WALLET = MY_WALLET_DATA.name;

export const NEW_SHARED_WALLET_BUTTON = {
  id: "new-shared-wallet",
  name: "New Shared Wallet",
};

export const NEW_SHARED_WALLET = "New Shared Wallet";

export const ROLES = {
  member: "member",
  admin: "admin",
  owner: "owner",
};

export const PERMISSION_OPTIONS = {
  [ROLES.member]: "Member",
  [ROLES.admin]: "Admin",
  [ROLES.owner]: "Owner",
};

export const NEW_PERMISSION_OPTIONS = {
  [ROLES.member]: LIMITED_ACCESS,
  [ROLES.admin]: FULL_ACCESS,
  [ROLES.owner]: "Owner",
};
